import { useCallback } from 'react';

import { TSetRoutePointErrors } from '../types/setRoutePointErrors';

const useDelRoutePointError = (setRoutePointErrors: TSetRoutePointErrors) => {
  const onDelRoutePointError = useCallback(
    (index: number) => {
      setRoutePointErrors((errors) => {
        errors[index] = null;
        return errors;
      });
    },
    [setRoutePointErrors],
  );

  return onDelRoutePointError;
};

export default useDelRoutePointError;
